import React from 'react';

const Gameficacao = () => {

  return (
    <div className="container-principal">
      <div className="modal-push">
        <div className="modal-flex-direction-row">
          {/* <img alt="imagem" className="logo-notificacao" src={LogoNotificacao} /> */}
          <h2 className="text-color-branco-titulo">Gameficacao: gerenciar</h2>
          <div className="div-acoes-push">
            <div className="icons-acoes-push">
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Gameficacao;